import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fc } from 'i18n';
import { close as closeSign } from 'assets/icons';
import Button from 'core/react/general/form/Button';
import { Preloader } from 'components/atoms/preloader';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { issueModalSelector } from 'core/redux/selectors/tep';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { InfoTable } from 'components/organisms/tables/info-table';
import { useUndraftColumns } from 'hooks/tep/leases/useUndraftColumns';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

export const UndraftModal: FC = () => {
  const dispatch = useDispatch();

  const { isLoading, error, leases } = useSelector(issueModalSelector);

  const columns = useUndraftColumns();

  const close = () => dispatch(leasesActions.close());

  const undraft = () => {
    dispatch(leasesActions.undraftMultiple.request({ ids: leases.map(({ id }) => id) }));
  };

  return (
    <ModalWrapper>
      <div className={styles.content}>
        <span className={styles.close} onClick={close}>
          <SvgWrapper width={26} height={26} details={closeSign} />
        </span>
        <div className={styles.title}>{fc('undraft')}</div>
        {/*@ts-ignore*/}
        <InfoTable isLoading={false} height={240} columns={columns} data={leases} />
        <div className={styles.totalCount}>{`Total No. Of Entries : ${leases.length}`}</div>
        <div className={styles.footer}>
          <div className={styles.error}>{error || ''}</div>
          <Button onClick={undraft} className={`${styles.submit} active`}>
            <span>{fc('undraft')}</span>
          </Button>
        </div>
        {isLoading && <Preloader />}
      </div>
    </ModalWrapper>
  );
};
